import React, { useState } from 'react';

import {  LoadingErrorImg, LoadingView } from './style';
import images from '../../Constant/images';

const SmartImage = ({ showDefault, src, alt, style }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [loadingErrored, setLoadingErrored] = useState(false);
  const handleLoadStart = () => {
    setIsLoading(true);
    setLoadingErrored(false);
  };

  const handleLoadEnd = () => {
    setIsLoading(false)
  };
  const handleError = () => {
    setIsLoading(false);
    setLoadingErrored(true)
  };
  return (
    <>
      <img
        src={src}
        alt={alt}
        onLoadStart={handleLoadStart}
        onLoad={handleLoadEnd}
        onError={handleError}
        style={{objectFit:'contain', ...style}}

      />
      {loadingErrored && showDefault ?
        <LoadingView>
          <LoadingErrorImg src={images.wrongImg} alt="Wrong Image" style={{height:'100%',width:'100%', alignSelf:'center'}} />
        </LoadingView>
        : isLoading && showDefault ? (
          <LoadingView>
            <LoadingErrorImg src={images.logoPlaceholder} alt="Placeholder" />
          </LoadingView>
        ) : null}
    </>
  );
};

export default SmartImage;

